import { faUser } from "@fortawesome/duotone-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { IconProps, JoonUIColor } from "@joonapp/web-shared"

const MeIcon = ({ color = JoonUIColor.icon.accent, size = 30 }: IconProps) => {
  return <FontAwesomeIcon icon={faUser} color={color} fontSize={size} />
}

export default MeIcon
